import {ResolveFn} from "@angular/router";
import {inject} from "@angular/core";
import {Store} from "@ngrx/store";
import {TechInventoryActions} from "@tech/pages/inventory/store/tech-inventory.actions-type";
import {of} from "rxjs";

export const techInventoryMissionDetailResolver: ResolveFn<null> = (route, state) => {
  const store = inject(Store);
  const missionId = route.paramMap.get('missionId');

  if (missionId) {
    const urlSegments = state.url.split('/');
    const idIndex = urlSegments.findIndex(segment => segment === missionId);
    const existingUrl = idIndex !== -1
      ? urlSegments.slice(idIndex + 1)
      : [];

    store.dispatch(TechInventoryActions.getMissionDetailById({
      missionId,
      existingUrl
    }));
  }

  return of(null);
};
